import React from 'react';
import { siteData } from '../data/mock';
import { Search, Cog, PlayCircle, ArrowRight } from 'lucide-react';

const HowItWorksSection = () => {
  const stepIcons = [Search, Cog, PlayCircle];

  return (
    <section id="how-it-works" className="section">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="heading-2 mb-4">{siteData.howItWorks.title}</h2>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 relative">
            {/* Connection line (desktop) */}
            <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200" />

            {siteData.howItWorks.steps.map((step, index) => {
              const Icon = stepIcons[index];
              return (
                <div key={index} className="relative">
                  <div className="flex flex-col items-center text-center">
                    {/* Step number */}
                    <div className="relative z-10">
                      <div className="w-32 h-32 rounded-3xl bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 flex items-center justify-center mb-6 shadow-sm">
                        <Icon size={48} className="text-blue-600" />
                      </div>
                      <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-blue-600 text-white font-bold flex items-center justify-center text-lg shadow-lg">
                        {step.number}
                      </div>
                    </div>

                    {/* Step content */}
                    <h3 className="heading-3 mb-3">{step.title}</h3>
                    <p className="text-slate-600">{step.description}</p>
                  </div>

                  {/* Arrow (mobile) */}
                  {index < siteData.howItWorks.steps.length - 1 && (
                    <div className="md:hidden flex justify-center my-6">
                      <ArrowRight size={24} className="text-blue-300 rotate-90" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Tagline */}
          <div className="text-center">
            <p className="text-2xl font-semibold text-slate-800">
              {siteData.howItWorks.tagline.split('. ').map((part, index) => (
                <span key={index}>
                  {index === 1 ? (
                    <span className="text-blue-600">{part}</span>
                  ) : (
                    <>{part}. <br className="sm:hidden" /></>
                  )}
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
